import { __assign, __awaiter, __generator } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Stack, Typography, useMediaQuery, } from "@mui/material";
import { forwardRef, useEffect, useMemo, useState } from "react";
import pickBy from "lodash/pickBy";
import isEmpty from "lodash/isEmpty";
import omit from "lodash/omit";
import * as yup from "yup";
import { useTheme } from "@mui/material/styles";
import { FieldsForm, PangeaModal, } from "@pangeacyber/react-mui-shared";
import { ObjectStore } from "../../../types";
import { useStoreFileViewerContext, useCreateShareContext, } from "../../../hooks/context";
import { getCreateShareFields } from "./fields";
import ShareSettings from "./ShareSettings";
import { alertOnError } from "../../AlertSnackbar/hooks";
var CreateButton = forwardRef(function (props, ref) {
    var _a;
    // @ts-ignore
    var isSaving = (_a = props === null || props === void 0 ? void 0 : props.children) === null || _a === void 0 ? void 0 : _a.endsWith("...");
    return (_jsx(Button, __assign({ ref: ref }, props, { sx: { minWidth: "100px" }, children: isSaving ? "Sending..." : "Send" })));
});
var ShareCreateRequestFields = new Set([
    "targets",
    "link_type",
    "expires_at",
    "max_access_count",
    "authenticators",
    "title",
    "message",
]);
var CreateShareModal = function (_a) {
    var _b, _c, _d, _e;
    var object = _a.object, open = _a.open, onClose = _a.onClose, onDone = _a.onDone;
    var theme = useTheme();
    var isLarge = useMediaQuery(theme.breakpoints.down("lg"));
    var _f = useCreateShareContext(), shareType = _f.shareType, loading = _f.loading, sent = _f.sent, password = _f.password, setLoading = _f.setLoading, setSent = _f.setSent, setErrors = _f.setErrors, setShareLink = _f.setShareLink, resetContext = _f.resetContext;
    var _g = useStoreFileViewerContext(), apiRef = _g.apiRef, triggerUpdate = _g.triggerUpdate, configurations = _g.configurations, defaultShareLinkTitle = _g.defaultShareLinkTitle;
    var _h = useState(false), settings = _h[0], setSettings = _h[1];
    var defaultAccessCount = (_c = (_b = configurations === null || configurations === void 0 ? void 0 : configurations.settings) === null || _b === void 0 ? void 0 : _b.defaultAccessCount) !== null && _c !== void 0 ? _c : 10;
    var _j = useState({
        shareType: shareType,
        targets: [],
        authenticators: [],
        link_type: "download",
        expires_at: "",
        max_access_count: defaultAccessCount,
        contentType: (_d = object === null || object === void 0 ? void 0 : object.type) !== null && _d !== void 0 ? _d : "file",
        authenticatorType: ObjectStore.ShareAuthenticatorType.Sms,
        title: defaultShareLinkTitle,
    }), obj = _j[0], setObj = _j[1];
    var _k = useState(obj), settingsObj = _k[0], setSettingsObj = _k[1];
    var _l = useState(false), settingsError = _l[0], setSettingsError = _l[1];
    useEffect(function () {
        var _a, _b;
        var date = (_a = configurations === null || configurations === void 0 ? void 0 : configurations.settings) === null || _a === void 0 ? void 0 : _a.defaultExpiresAt;
        if (!date) {
            date = new Date();
            date.setDate(date.getDate() + 7);
        }
        var newObj = {
            shareType: shareType,
            targets: [],
            authenticators: [],
            link_type: "download",
            expires_at: date.toISOString(),
            max_access_count: defaultAccessCount,
            contentType: (_b = object === null || object === void 0 ? void 0 : object.type) !== null && _b !== void 0 ? _b : "file",
            authenticatorType: ObjectStore.ShareAuthenticatorType.Sms,
            title: defaultShareLinkTitle,
        };
        setObj(newObj);
        setSettingsObj(newObj);
        setSettingsError(false);
    }, [object, defaultShareLinkTitle]);
    useEffect(function () {
        if (!isLarge && open) {
            setSettings(true);
        }
        else if (isLarge && open) {
            setSettings(false);
        }
    }, [isLarge, open]);
    var handleClose = function () {
        var sharePassword = password;
        resetContext();
        onClose(sharePassword);
    };
    var handleCreateShare = function (body) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c;
        return __generator(this, function (_d) {
            if (sent)
                return [2 /*return*/, false];
            if (!((_a = apiRef.share) === null || _a === void 0 ? void 0 : _a.create))
                return [2 /*return*/, false];
            setLoading(true);
            setShareLink(undefined);
            return [2 /*return*/, apiRef.share
                    .create({
                    links: (_c = ((_b = body === null || body === void 0 ? void 0 : body.authenticators) !== null && _b !== void 0 ? _b : [])) === null || _c === void 0 ? void 0 : _c.map(function (auth) {
                        var _a, _b;
                        var send_params = shareType === "email"
                            ? {
                                send_params: {
                                    recipient_email: auth.recipient_email,
                                    sender_email: ((_a = configurations === null || configurations === void 0 ? void 0 : configurations.sender) === null || _a === void 0 ? void 0 : _a.email) || "no-reply@pangea.cloud",
                                    sender_name: (_b = configurations === null || configurations === void 0 ? void 0 : configurations.sender) === null || _b === void 0 ? void 0 : _b.name,
                                },
                            }
                            : {};
                        return __assign(__assign(__assign({}, body), { targets: [object.id], authenticators: [omit(auth, ["recipient_email", "phone_number"])] }), send_params);
                    }),
                })
                    .then(function (response) {
                    var _a, _b;
                    triggerUpdate();
                    if (shareType === "link") {
                        var shares = (_b = (_a = response === null || response === void 0 ? void 0 : response.result) === null || _a === void 0 ? void 0 : _a.share_link_objects) !== null && _b !== void 0 ? _b : [];
                        setSent(true);
                        setShareLink(shares[0]);
                    }
                })
                    .catch(function (err) {
                    alertOnError(err);
                    setLoading(false);
                    return false;
                })
                    .finally(function () {
                    setLoading(false);
                    if (shareType === "email") {
                        handleClose();
                        onDone();
                    }
                })];
        });
    }); };
    var fields = useMemo(function () {
        return getCreateShareFields();
    }, [object === null || object === void 0 ? void 0 : object.type, configurations]);
    return (_jsx(PangeaModal, { open: open, onClose: handleClose, displayCloseIcon: true, title: "", header: _jsxs(Stack, { direction: "row", width: "100%", alignItems: "center", justifyContent: "space-between", children: [_jsx(Typography, { variant: "h5", sx: { overflow: "hidden", wordBreak: "break-all" }, children: "Secure link for ".concat((_e = object === null || object === void 0 ? void 0 : object.name) !== null && _e !== void 0 ? _e : "unknown") }), _jsx(ShareSettings, { object: settingsObj, onSubmit: function (values) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                        return [2 /*return*/, setSettingsObj(function (state) { return (__assign(__assign({}, state), values)); })];
                    }); }); }, onError: function (errors) {
                        setSettingsError(!isEmpty(errors));
                    }, open: settings, setOpen: setSettings })] }), size: "medium", children: _jsx(FieldsForm, { object: obj, fields: fields, onSubmit: function (values) {
                return handleCreateShare(
                // @ts-ignore
                pickBy(__assign(__assign({}, values), { expires_at: settingsObj.expires_at, max_access_count: settingsObj.max_access_count }), function (v, k) { return !!v && ShareCreateRequestFields.has(k); })).then(function (isSuccess) {
                    if (isSuccess && shareType === "email") {
                        handleClose();
                    }
                });
            }, validation: {
                schema: yup.object().shape({
                    authenticators: yup
                        .array()
                        .min(1, "At least one recipient is required.")
                        .test("validate-phone", "Missing recipient phone number.", function (value, context) {
                        var _a, _b;
                        if (((_a = context === null || context === void 0 ? void 0 : context.parent) === null || _a === void 0 ? void 0 : _a.shareType) === "link") {
                            return true;
                        }
                        var authType_ = ((_b = context === null || context === void 0 ? void 0 : context.parent) === null || _b === void 0 ? void 0 : _b.authenticatorType) || "";
                        var isValid = true;
                        value.forEach(function (r) {
                            if (authType_ === ObjectStore.ShareAuthenticatorType.Sms &&
                                !r.phone_number) {
                                isValid = false;
                            }
                        });
                        return isValid;
                    }),
                    password: yup
                        .string()
                        .test("validate-password", "A password is required.", function (value, context) {
                        var _a, _b;
                        if (((_a = context === null || context === void 0 ? void 0 : context.parent) === null || _a === void 0 ? void 0 : _a.shareType) === "link") {
                            return true;
                        }
                        var firstAuth = (_b = context === null || context === void 0 ? void 0 : context.parent) === null || _b === void 0 ? void 0 : _b.authenticators[0];
                        var authType = (firstAuth === null || firstAuth === void 0 ? void 0 : firstAuth.auth_type) || "";
                        var isValid = authType !== ObjectStore.ShareAuthenticatorType.Password ||
                            (authType === ObjectStore.ShareAuthenticatorType.Password &&
                                !!(firstAuth === null || firstAuth === void 0 ? void 0 : firstAuth.auth_context));
                        setErrors(isValid ? {} : { password: "A password is required." });
                        return isValid;
                    }),
                }),
            }, disabled: loading || settingsError, clearable: true, clearButtonLabel: shareType === "link" ? "Done" : "Cancel", onCancel: handleClose, autoSave: shareType === "link" ? true : false, 
            // @ts-ignore
            SaveButton: CreateButton, StackSx: {
                ".MuiFormControl-root": {
                    margin: 0,
                },
            } }) }));
};
export default CreateShareModal;
